import { useState, useEffect } from "react";
import axios from "axios";

export default function useObtenerUsuario(loggedIn) {
  const [usuario, guardarUsuario] = useState(undefined);
  const [error, guardarError] = useState(false);

  useEffect(() => {
    const obtenerUsuario = () => {
      axios
        .get("/api/usuarios/info")
        .then((usuarioRes) => guardarUsuario(usuarioRes.data))
        .catch((error) => {
          guardarError(true);
        });
    };
    if (loggedIn === true) {
      obtenerUsuario();
    }
    return () => {
      guardarUsuario(undefined);
    };
  }, [loggedIn]);

  return [usuario, error];
}
